import React from 'react';
import c from 'classnames';

import { SCREEN_NORMAL } from '../../../config/constants';

import useWindowDimensions from '../../../helpers/useWindowDimensions';
import NavigationMainMenuSubComponentKP from './NavigationMainMenuSubComponentKP';

import './style.scss';

const NavigationMainMenuKP = ({
  items,
  active,
  setActive
}) => {
  const { width } = useWindowDimensions();

  const classNames = c('NavigationMainMenuDesktop');

  return (
    <div className={classNames}>
        {(active || width >= SCREEN_NORMAL) && (
          <NavigationMainMenuSubComponentKP
            setActive={setActive}
            active={active}
            items={items}
          />
        )}
    </div>
  );
};

export default NavigationMainMenuKP;
